import { isMobileViewHook } from "@/customHooks/isMobileViewHook";
import { cn } from "@/helper/HelperFunction";
import { useEffect, useState } from "react";
import styles from "./Logo.module.css";
import { logo, logoIcon } from "@/constant/imagePath";

export default function Logo({
  variant = "logo",
  type,
  isCollapsed,
  disableMobileChange = false,
  customClass,
  theme = "light",
}) {
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    if (!disableMobileChange) {
      isMobileViewHook(setMobile, 480);
    }
  }, [disableMobileChange]);

  const logoSrcVariant = (theme = "light") => {
    return {
      icon: logoIcon,
      logo: logo,
      footer: logo,
    };
  };

  return (
    <div
      className={cn(
        styles.logo,
        type === "footer" && styles.footerLogo,
        type === "header" && styles.headerLogo,
        customClass
      )}
    >
      <img src={logoSrcVariant(theme)[variant]} alt="Logo" unoptimized={true} />
    </div>
  );
}
